import { APP_SETTINGS } from "../../../../config";
import api from '../../api/axiosInstance'; 

const getAuthHeaders = (token) => {
    if (!token) {
        console.error("Token is missing for API request.");
        return {};
    }
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getDashboard = (token) => {
    return api.get(APP_SETTINGS.API_PATH.DASHBOARD.get, getAuthHeaders(token));
};